import { api } from "services"

export async function getCarriers() {
  const { data } = await api.get("/carriers?asList=1")
  
  return data
}